<template>
  <div class="doc-layout">
    <!-- 左侧导航 -->
    <aside class="sidebar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索文档"
        prefix-icon="el-icon-search"
        class="search-input"
      />

      <ul class="nav-list">
        <li
          v-for="(item, index) in filteredTableData"
          :key="item.document_id"
          :class="['nav-item', { active: activeParentIndex === index }]"
          @click="handleSelect(index)"
        >
          {{ item.name }}
          <ul v-if="item.flag" class="sub-nav">
            <li
              v-for="(child, cIdx) in item.document_sections"
              :key="child.document_sections_id"
              :class="['sub-item', { active: activeSubIndex === cIdx }]"
              @click.stop="handleSelectA(child.document_sections_id, cIdx)"
            >
              {{ child.name }}
            </li>
          </ul>
        </li>
      </ul>
    </aside>

    <!-- 右侧正文 -->
    <main class="content">
      <div v-if="detail">
        <h1 class="doc-title">{{ detail.name }}</h1>
        <div class="doc-body" ref="docBody" v-html="detail.intro"></div>
      </div>
    </main>

    <!-- 图片预览组件 -->
    <image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="imageList"
      :initial-index="viewerIndex"
    />
  </div>
</template>

<script>
import DocumentApi from '@/api/document.js';
// 引入 Element UI 内置 ImageViewer
import ImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  components: { ImageViewer },
  data() {
    return {
      tableData: [],
      searchQuery: "",
      activeParentIndex: null,
      activeSubIndex: null,
      formInline: {},
      detail: {
        name: "",
        intro: ""
      },
      showViewer: false,   // 是否显示图片预览
      imageList: [],       // 所有图片地址
      viewerIndex: 0       // 当前预览图片的索引
    };
  },
  created() {
    this.getTableList();
  },
    computed: {
    filteredTableData() {
      if (!this.searchQuery) return this.tableData;
      return this.tableData.filter(item =>
        item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        item.document_sections.some(section =>
          section.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
    }
  },
  watch: {
    "detail.intro"() {
      this.$nextTick(() => {
        this.bindImagePreview();
      });
    }
  },
  methods: {
    getTableList() {
      DocumentApi.search(this.formInline, true).then(data => {
        this.tableData = data.data;
      });
    },
    getDetail(id) {
      DocumentApi.searchDetail({ document_sections_id: id }, true).then(data => {
        this.detail = data.data;
        this.$nextTick(() => {
          this.bindImagePreview();
        });
      });
    },
    handleSelect(index) {
      this.activeParentIndex = this.activeParentIndex === index ? null : index;
      this.activeSubIndex = null;
      this.tableData.forEach((item, i) => (item.flag = i === index ? !item.flag : false));
    },
    handleSelectA(id, subIdx) {
      this.activeSubIndex = subIdx;
      this.getDetail(id);
    },
    // 绑定富文本图片点击预览
    bindImagePreview() {
      const container = this.$refs.docBody;
      if (!container) return;

      const imgs = container.querySelectorAll("img");
      this.imageList = Array.from(imgs).map(img => img.src);

      imgs.forEach((img, idx) => {
        img.style.cursor = "pointer";
        img.onclick = () => {
          this.viewerIndex = idx;
          this.showViewer = true;
        };
      });
    },
    closeViewer() {
      this.showViewer = false;
    }
  }
};
</script>

<style scoped>
.doc-layout {
  display: flex;
  min-height: 100vh;
  background: #fff;
}

.sidebar {
  width: 260px;
  background: #f9fafb;
  border-right: 1px solid #eaecef;
  padding: 20px;
  overflow-y: auto;
}

.search-input {
  margin-bottom: 20px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  font-size: 14px;
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
}
.nav-item.active {
  color: #419eff;
}

.sub-nav {
  list-style: none;
  padding-left: 16px;
  margin-top: 6px;
}

.sub-item {
  padding: 6px 0;
  cursor: pointer;
  font-size: 14px;
  color: #666;
    font-size: 12px;
}
.sub-item.active {
  color: #419eff;
  font-weight: 600;
}

.content {
  flex: 1;
  padding: 40px;
  overflow-y: auto;
}

.doc-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #2c3e50;
}

.doc-body {
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}
.doc-body h2 {
  font-size: 22px;
  margin-top: 30px;
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}
.doc-body p {
  margin: 16px 0;
}
.doc-body img {
  max-width: 100%;
  border-radius: 6px;
  margin: 12px 0;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/document/index/search.vue